// Use the configured API in development. If a production bundle was built
// with the repository's localhost default, fall back to the same-origin API
// instead of attempting to call the customer's own computer.
const configured = import.meta.env.VITE_API_BASE;
const browserHost = typeof window !== "undefined" ? window.location.hostname : "localhost";
const pointsAtLocalhost = /^https?:\/\/(localhost|127\.0\.0\.1)(:\d+)?(?:\/|$)/u.test(configured || "");
export const API_BASE = pointsAtLocalhost && !["localhost", "127.0.0.1"].includes(browserHost)
  ? "/api"
  : (configured || "/api");
